import React, { useState, useEffect } from "react";
import { Card, Button, Row, Col, Drawer, Badge, Typography, Tag } from "antd";
import { ShoppingCartOutlined, FireOutlined } from "@ant-design/icons";
import menuData from "../data/data.json"; 
import { APP_CONFIG } from "../composant/appConfig";

const { Title, Paragraph, Text } = Typography;
const { Meta } = Card;

const Ecommerce = () => {
  const [cart, setCart] = useState([]);
  const [open, setOpen] = useState(false);
  // Nouvel état pour la catégorie sélectionnée ("Touts" par défaut)
  const [selectedCategory, setSelectedCategory] = useState("Tous");

  /* ===== TEXTE ANIMÉ DU HEADER ===== */
  const texts = [
    "Découvrez nos plats savoureux",
    "Commandez en quelques secondes",
    "Livraison rapide via WhatsApp"
  ];
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % texts.length);
        setFade(true);
      }, 300);
    }, 3000);
    return () => clearInterval(interval);
  }, [texts.length]);

  // Liste unique des catégories pour le menu
  const categories = ["Tous", ...menuData.map(item => item.category)];

  // Filtrage des données selon la catégorie choisie
  const filteredData = selectedCategory === "Tous" 
    ? menuData 
    : menuData.filter(item => item.category === selectedCategory);

  /* ===== GESTION DU PANIER ===== */
  const addToCart = (product) => {
    setCart((prev) => {
      const exist = prev.find((p) => p.name === product.name);
      if (exist) {
        return prev.map((p) =>
          p.name === product.name ? { ...p, qty: p.qty + 1 } : p
        );
      }
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const updateQty = (name, action) => {
    setCart((prev) =>
      prev.map((item) => {
        if (item.name !== name) return item;
        if (action === "inc") return { ...item, qty: item.qty + 1 };
        if (action === "dec")
          return item.qty > 1 ? { ...item, qty: item.qty - 1 } : item;
        return item;
      })
    );
  };

  const removeItem = (name) => {
    setCart((prev) => prev.filter((item) => item.name !== name));
  };

  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  const generateWhatsAppLink = () => {
    let msg = "*Nouvelle Commande - RESTO SADEM*\n\n";
    cart.forEach((item) => {
      msg += `• ${item.qty}x *${item.name}* - ${item.price * item.qty} FCFA\n`;
    });
    msg += `\n*Total: ${total} FCFA*`;
    const phone = APP_CONFIG.phone;
    return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
  };

  return (
    <>
      <style>{`
        html, body { margin: 0; background: #f9f9f9; font-family: 'Inter', sans-serif; overflow-x: hidden; }
        .container { max-width: 1200px; margin: 0 auto; padding: 10px 12px; }
        
        .sticky-header { 
          position: sticky; 
          top: 0; 
          z-index: 999; 
          background: #fff; 
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

        /* Menu de catégories horizontal */
        .category-nav {
          display: flex;
          gap: 10px;
          overflow-x: auto;
          padding: 10px 12px;
          background: #fff;
          white-space: nowrap;
          scrollbar-width: none; /* Cache scrollbar Firefox */
        }
        .category-nav::-webkit-scrollbar { display: none; } /* Cache scrollbar Chrome */

        .category-item {
          padding: 8px 20px;
          border-radius: 20px;
          background: #f3f4f6;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s;
          border: 1px solid transparent;
        }

        .category-item.active {
          background: #edbb05;
          color: #000;
          box-shadow: 0 4px 10px rgba(237, 187, 5, 0.3);
        }

        .category-title { 
          margin-top: 20px !important; 
          margin-bottom: 20px !important; 
          border-left: 5px solid #edbb05; 
          padding-left: 15px; 
          font-weight: 800;
        }

        .product-img { height: 160px; width: 100%; object-fit: cover; background: #eee; border-radius: 8px 8px 0 0; }
        .cart-btn { position: fixed; bottom: 20px; right: 20px; z-index: 1000; }
        .ant-btn-primary { background-color: #edbb05 !important; border-color: #edbb05 !important; color: #000 !important; font-weight: bold !important; border-radius: 8px !important; }
        
        .product-card {
          border-radius: 12px;
          overflow: hidden;
          transition: transform 0.3s;
        }
        .product-card:hover { transform: translateY(-5px); }
      `}</style>

      {/* ===== HEADER AVEC RECHERCHE CATEGORIE ===== */}
      <div className="sticky-header">
        <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 5 }}>
          <img src="/logo.png" alt="logo" style={{ height: 40 }} />
          <div style={{ textAlign: 'center' }}>
            <Title level={5} style={{ margin: 0 }}>RESTO SADEM</Title>
            <Text style={{ fontSize: 10, color: "#edbb05", opacity: fade ? 1 : 0, transition: "0.3s" }}>
              {texts[index]}
            </Text>
          </div>
          <div style={{ width: 40 }} /> {/* Spacer pour centrer le titre */}
        </div>

        {/* BARRE DE CATEGORIES */}
        <div className="category-nav">
          {categories.map((cat) => (
            <div 
              key={cat} 
              className={`category-item ${selectedCategory === cat ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat === "Tous" && <FireOutlined style={{ marginRight: 5 }} />}
              {cat}
            </div>
          ))}
        </div>
      </div>

      {/* ===== LISTE DES PRODUITS FILTRÉS ===== */}
      <div className="container">
        {filteredData.length > 0 ? (
          filteredData.map((categoryData, idx) => (
            <div key={idx} style={{ marginBottom: 40 }}>
              <Title level={3} className="category-title">
                {categoryData.category}
              </Title>
              
              <Row gutter={[16, 16]}>
                {categoryData.items.map((product, pIdx) => (
                  <Col xs={12} sm={12} md={8} lg={6} key={`${idx}-${pIdx}`}>
                    <Card
                      hoverable
                      className="product-card"
                      size="small"
                      cover={
                        <img
                          src={product.image || "/image.png"} 
                          alt={product.name} 
                          className="product-img" 
                          loading="lazy"
                        />
                      }
                    >
                      <Meta
                        title={<span style={{ fontSize: 14, fontWeight: 'bold' }}>{product.name}</span>}
                        description={
                          <Text strong style={{ color: '#edbb05', fontSize: 15 }}>
                            {String(product.price).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} FCFA
                          </Text>
                        }
                      />
                      <Button
                        type="primary"
                        size="middle"
                        style={{ marginTop: 12, width: "100%" }}
                        onClick={() => addToCart(product)}
                      >
                        Ajouter
                      </Button>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ))
        ) : (
          <div style={{ textAlign: 'center', padding: '50px 0' }}>
            <Text type="secondary">Aucun produit trouvé dans cette catégorie.</Text>
          </div>
        )}
      </div>

      {/* ===== BOUTON PANIER FLOTTANT ===== */}
      <div className="cart-btn">
        <Badge count={cart.reduce((a, b) => a + b.qty, 0)} offset={[-5, 5]}>
          <Button
            type="primary"
            shape="circle"
            style={{ height: 65, width: 65, boxShadow: '0 8px 24px rgba(237, 187, 5, 0.4)' }}
            icon={<ShoppingCartOutlined style={{ fontSize: 28 }} />}
            onClick={() => setOpen(true)}
          />
        </Badge>
      </div>

      {/* ===== PANIER (DRAWER) ===== */}
      <Drawer
        title={<Title level={4} style={{ margin: 0 }}>Ma Commande</Title>}
        open={open}
        onClose={() => setOpen(false)}
        width={350}
      >
        {cart.length === 0 ? (
          <div style={{ textAlign: 'center', marginTop: 50 }}>
            <Paragraph type="secondary">Votre panier est vide</Paragraph>
          </div>
        ) : (
          <>
            <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
              {cart.map((item) => (
                <div key={item.name} style={{ marginBottom: 15, padding: 12, background: '#f9f9f9', borderRadius: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Text strong>{item.name}</Text>
                    <Text strong>{item.price * item.qty} F</Text>
                  </div>
                  <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center", marginTop: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <Button shape="circle" size="small" onClick={() => updateQty(item.name, "dec")}>-</Button>
                      <Text strong>{item.qty}</Text>
                      <Button shape="circle" size="small" onClick={() => updateQty(item.name, "inc")}>+</Button>
                    </div>
                    <Button type="link" danger size="small" onClick={() => removeItem(item.name)}>Retirer</Button>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', padding: 20, background: '#fff', borderTop: '1px solid #eee' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
                <Text size="large">Total à payer :</Text>
                <Title level={3} style={{ margin: 0, color: '#edbb05' }}>{total} FCFA</Title>
              </div>
              <Button
                type="primary"
                size="large"
                style={{ width: "100%", height: 55, fontSize: 18 }}
                href={generateWhatsAppLink()}
                target="_blank"
              >
                Commander via WhatsApp
              </Button>
            </div>
          </>
        )}
      </Drawer>
    </>
  );
};

export default Ecommerce;